import { render, staticRenderFns } from "./itemDashboard.vue?vue&type=template&id=40e1932e&"
import script from "./itemDashboard.vue?vue&type=script&lang=js&"
export * from "./itemDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports